export default __webpack_public_path__ + "static/media/bluePT.e116990d.png";